<template>
  <div v-if="!selecionouPisCofins">
    <!-- ajustar pis cofins para simples nacional com mais de uma seleção -->
    <div class="pis-cofins-content" v-for="(subimposto, index) in imposto.dados">
      <RadioButton
        v-if="imposto.dados.length > 1"
        :classe="imposto.classe"
        :seleciona="seleciona"
        :imposto="subimposto"
        :name="'radio'"
      />
      <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
        <Cabecalho :titulo="subimposto.label" :aliquota="subimposto.aliquota" />

        <Separador
          v-if="subimposto.label != 'Alíquota Regra Geral' && subimposto.ncm"
          :dado="subimposto"
        />
        <Ncm v-if="subimposto.label != 'Alíquota Regra Geral'" :ncm="subimposto.ncm" />
        <Separador v-if="subimposto.ncm && subimposto.descricao" :dado="subimposto" />

        <Descricao :titulo="'Descrição'" :descricao="subimposto.descricao" />
      </Registro>
    </div>
  </div>

  <!-- APÓS SELEÇÃO -->
  <div class="pis-cofins-content" v-else>
    <EditButton v-if="imposto.dados.length > 1" :edita="edita" :classe="imposto.classe" />
    <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
      <Cabecalho
        :titulo="registroSelecionado.label"
        :aliquota="registroSelecionado.aliquota"
      />

      <Separador v-if="!registroSelecionado.blSimplesNacional" :dado="registroSelecionado" />

      <Ncm
        v-if="registroSelecionado.ncm && !registroSelecionado.blSimplesNacional"
        :ncm="registroSelecionado.ncm"
      />
      <Separador
        v-if="registroSelecionado.ncm && !registroSelecionado.blSimplesNacional"
        :dado="registroSelecionado"
      />

      <Descricao :titulo="'Descrição'" :descricao="registroSelecionado.descricao" />

      <Cabecalho
        v-if="registroSelecionado.vigencia_fim"
        :tipo="'data'"
        :titulo="'Vigência'"
        :aliquota="registroSelecionado.vigencia_fim"
      />

      <Notificacao
        v-if="registroSelecionado.alerta"
        :tipo="'alerta'"
        :texto="registroSelecionado.alerta"
      />
      <GrupoNotificacao
        v-if="registroSelecionado"
        :registro="registroSelecionado"
        :baseLegalNota="registroSelecionado.base_legal_nota"
      />

      <div class="sub-registro-container">
        <!-- AS LABELS PIS E COFINS DEVEM SER MANDADAS PELO BANCO QUANDO FOREM REFATORAR O IMPOSTO 
       POIS ELAS MUDAM DE ACORDO COM TIPO DE OPERACAO-->
        <RegistroPis
          v-if="exibeSubRegistroPis"
          :classe="imposto.classe"
          :registroSelecionado="registroSelecionado"
        />
        <RegistroCofins
          v-if="exibeSubRegistroCofins"
          :classe="imposto.classe"
          :registroSelecionado="registroSelecionado"
        />
      </div>
      <Separador
        v-if="
          (registroSelecionado.alerta ||
            registroSelecionado.obs ||
            registroSelecionado.nota ||
            registroSelecionado.obs_aplic ||
            registroSelecionado.obs_inaplic ||
            registroSelecionado.vigencia_fim) &&
            baseLegal
        "
        :dado="registroSelecionado"
      />

      <BaseLegal v-if="baseLegal" :base_legal="baseLegal" :classe="imposto.classe" />
    </Registro>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import SubRegistro from "@/components/SubRegistro/SubRegistro.vue";
import RegistroPis from "@/components/RegistrosPisCofins/RegistroPis.vue";
import RegistroCofins from "@/components/RegistrosPisCofins/RegistroCofins.vue";
import Memoria from "../Memoria/Memoria.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

export default {
  name: "RegistrosPisCofins",

  props: {
    imposto: Array | Object,
    registroSelecionado: Array | Object,
    selecionouPisCofins: Boolean,
    seleciona: Function,
    edita: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Notificacao,
    GrupoNotificacao,
    RadioButton,
    Registro,
    RegistroPis,
    RegistroCofins,
    Separador,
    SubRegistro,
    Ncm,
    Memoria
  },

  created() {
    //se tiver apenas um resultado, seleciona o mesmo.
    if (this.imposto.dados.length == 1) {
      this.seleciona(this.imposto.dados[0]);
    }
  },

  computed: {
    baseLegal() {
      if (
        !this.registroSelecionado.base_legal &&
        this.registroSelecionado.base_legal_pis == this.registroSelecionado.base_legal_cofins &&
        !this.exibeSubRegistroPis &&
        !this.exibeSubRegistroCofins
      ) {
        return this.registroSelecionado.base_legal_pis;
      }
      return this.registroSelecionado.base_legal;
    },
    exibeSubRegistroPis() {
      if (
        this.registroSelecionado.aliquota_efetiva_pis ||
        this.registroSelecionado.aliquota_pis ||
        this.registroSelecionado.adicional_aliquota_pis ||
        this.registroSelecionado.aliquota_pis_excedente ||
        this.registroSelecionado.base_legal_pis
      ) {
        return true;
      }
      return false;
    },
    exibeSubRegistroCofins() {
      if (
        this.imposto.aliquota_efetiva_cofins ||
        this.registroSelecionado.aliquota_cofins ||
        this.registroSelecionado.adicional_aliquota_cofins ||
        this.registroSelecionado.aliquota_efetiva_cofins ||
        this.registroSelecionado.aliquota_cofins_excedente ||
        this.registroSelecionado.base_legal_cofins
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.pis-cofins-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.sub-registro-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
